import cn from '@/lib/cs';
import React from 'react';

const RecorderIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M12.2 0C10.5.1 8 1.7 8 3.6l.1 5c0 .7.2 1.1.3 1.5.2.4.3.9.3 1.5 0 1 .4 1.4 1.1 2l.5.7c.5.5.8.9 1.6.9 1 0 2.1-.2 2.9-1 1.3-1.2 1-7.6.8-9.4l-.1-1.2c0-1 0-2.4-.8-3C14-.2 13 0 12.2 0Z"
		/>
		<path
			fill="currentColor"
			d="m21 12.7-.2-1.2c-.3 0-.6-.2-.8-.4-.6-.3-1-.6-1.8 0 0 .9-.2 1.8-.5 2.5s-.8 1.1-1.3 1.6-.8 1.2-1.4 1.5a13.1 13.1 0 0 1-4 .9c-.6 0-1 0-1.7-.3-.5-.2-.7-.6-1-1l-.6-.9a7 7 0 0 1-2.2-4.5c-.8-.3-1.1 0-1.6.3l-.9.5c0 1 .2 1.5.5 2.2l.3 1c.3.8.6 1.6 1.2 2.2l.6.8c.5.7 1 1.3 1.6 1.7.6.3 1.4.3 2.2.3h.6v2.2c0 .8.5 1.9 1.3 1.9h1.4c.8 0 1.3-1.1 1.3-1.9v-2.4c.8 0 1.6-.1 2.3-.5 1-.5 1.7-1.3 2.4-2l.7-.8c.6-.5 1.2-1.1 1.4-1.8.3-.7.2-1.3.1-2Z"
		/>
	</svg>
);

export default RecorderIcon;
